<template>
  <el-button
      type="text"
      data-test-id="refresh-button"
      :disabled="disabled"
      @click="onClick">
    <div>
      <img
          :src="refreshIcon"
          class="refresh-icon">
      <span
          v-if="showText"
          data-test-id="refresh-button-text"
          class="refresh-button">
        {{ text }}
      </span>
    </div>
  </el-button>
</template>

<script>
import cacheControlMixin from "@/mixins/cacheControlMixin";

export default {
  name: "RefreshButton",
  mixins: [cacheControlMixin],
  props: {
    disabled: Boolean,
    text: {
      type: [String, Boolean],
      default() {
        return "Refresh";
      },
    },
  },
  data() {
    return {
      icons: {
        refresh: require("@/assets/icons/refresh.svg"),
        refreshDisabled: require("@/assets/icons/refresh-disabled.svg"),
      },
    };
  },
  computed: {
    refreshIcon() {
      return this.disabled ? this.icons.refreshDisabled : this.icons.refresh;
    },
    showText() {
      return typeof this.text !== "boolean";
    },
  },
  methods: {
    onClick() {
      this.addCacheControl("no-cache");
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
.refresh-icon {
  vertical-align: text-bottom;
  height: 20px;
  width: 17px;
  margin-right: 8px;
}

.refresh-button {
  .new-ui & {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #10628a;
  }
}
</style>
